import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";


const greenMarkProjectApi = createApi({
    reducerPath: 'greenMarkProjectApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getGMAPGreenMarkProjectList: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/GMAPAccount/GetGMAPGreenMarkProjectList?id=${Number(details)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteGMAPGreenMarkProject: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/DeleteGMAPGreenMarkProject',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditGMAPGreenMarkProject: builder.mutation({
            query: (details) => ({
                url: '/GMAPAccount/AddEditGMAPGreenMarkProject',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getGMAPGreenMarkProjectDetailsBySource: builder.query({
            query:(details) => ({
                url: (
                    `/CPD/GetGreenMarkProjectDeatilsBySource?memberId=${encryptAES(details.memberId)}&projectId=${encryptAES(details.projectId)}&source=${encryptAES(details.source)}`
                ),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditGMProject: builder.mutation({
            query: (details) => ({
                url: '/CPD/AddEditGMProject',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useDeleteGMAPGreenMarkProjectMutation,
    useAddEditGMAPGreenMarkProjectMutation,
    useLazyGetGMAPGreenMarkProjectListQuery,
    useLazyGetGMAPGreenMarkProjectDetailsBySourceQuery,
    useAddEditGMProjectMutation
} = greenMarkProjectApi;

export default greenMarkProjectApi;